import { showSuccess, showError } from 'utils/messages';

import Lead from 'app/models/lead';

import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/lead_gather_modal';

export const TEXT_AREA_MAX_CHARS = 300;

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'submit #lead-form': 'submit',
    'keyup #comments': 'updateTextAreaCharCount',
  },

  initialize({ source, email }) {
    this.email = email;
    this.source = source;
    this.model = new Lead({});
  },

  context() {
    return {
      source: this.source || 'EasyPost',
      textAreaMaxLength: TEXT_AREA_MAX_CHARS,
      email: this.email,
      volumeOptions: [
        '0-100',
        '101-1,000',
        '1,001-10,000',
        '10,001-100,000',
        '100,001-1M',
        '1M+',
      ],
    };
  },

  updateTextAreaCharCount() {
    const textAreaChars = this.$('#comments').val().length;
    this.$('#chars-remaining').text(TEXT_AREA_MAX_CHARS - textAreaChars);
  },

  submit(e) {
    if (e) { e.preventDefault(); }

    const self = this;
    const email = this.$('input#lead-email').val();
    const volume = this.$('select#volume-option').val();
    const comments = this.$('textarea#comments').val();

    if (email) {
      this.model.save({ source: this.source, email, volume, comments }, {
        success: () => {
          this.close();
          showSuccess(`Your inquiry has been submitted to EasyPost! You will be contacted at ${email}.`);
        },

        error() {
          self.close();
          showError('Unfortunately the browser was unable to communicate with the EasyPost servers, please mail support@easypost.com to get in touch!');
        },
      });
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/lead_gather_modal.js